import React from "react";
import { RuleItem } from "../interfaces/RuleItem";

const ruleItemInitial: RuleItem = {} as RuleItem;

export const RuleItemContext = React.createContext<RuleItem>({
  ...ruleItemInitial,
});
